import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState, useMemo } from 'react';

function useToggle() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var reverseValue = arguments.length > 1 ? arguments[1] : undefined;

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var reverseValueOrigin = useMemo(function () {
    return reverseValue === undefined ? !defaultValue : reverseValue;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [reverseValue]); // 切换返回值

  var toggle = useCallback(function (value) {
    setState(function (oldState) {
      // 强制返回状态值，适用于点击操作
      if (value !== undefined) {
        return value;
      }

      return oldState === defaultValue ? reverseValueOrigin : defaultValue;
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // 设置默认值

  var setLeft = useCallback(function () {
    setState(defaultValue); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setState]); // 设置取反值

  var setRight = useCallback(function () {
    setState(reverseValueOrigin); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setState]);
  return {
    state: state,
    toggle: toggle,
    setLeft: setLeft,
    setRight: setRight
  };
}

export default useToggle;